import { activitiesConstants } from "@data/constants/activitiesConstants"

export function pauseActivity(paused) {
    return { type: activitiesConstants.PAUSE_ACTIVITY, data: paused }
}

export function setOngoingActivity(data) {
    return { type: activitiesConstants.ONGOING_ACTIVITY, data }
}

export function setCameraStatus(cameraOn, reusesLiveTrack = false) {
    return {
        type: activitiesConstants.SET_CAMERA_STATUS,
        cameraOn,
        reusesLiveTrack,
    }
}

export function audioRecordingStatus(data) {
    return { type: activitiesConstants.AUDIO_STATUS, data }
}

export function updateActivityEvent(data) {
    return { type: activitiesConstants.UPDATE_ACTIVITY_CHRONO, data }
}

export function setCurrentActivity(data) {
    return { type: activitiesConstants.SET_CURRENT_ACTIVITY, data }
}

export function setTimerState(activityId, time, seenLottie) {
    return {
        type: activitiesConstants.SET_TIMER_STATE,
        payload: { activityId, time, seenLottie },
    }
}

export function markActivitiesAsDeleted(activityIds) {
    return {
        type: activitiesConstants.MARK_ACTIVITIES_AS_DELETED,
        activityIds,
    }
}

export function addPendingAttachment({ activityId, stepIndex, tmpKey }) {
    return {
        type: activitiesConstants.ADD_PENDING_ATTACHMENT,
        payload: { activityId, stepIndex, tmpKey },
    }
}

export function clearPendingAttachments({ activityId }) {
    return {
        type: activitiesConstants.CLEAR_PENDING_ATTACHMENTS,
        payload: { activityId },
    }
}
